import React, { useState } from 'react';
import { FaFacebookSquare, FaWindowClose } from 'react-icons/fa';
import { ImGoogle2 } from 'react-icons/im';
import axios from 'axios';

const ResetPassword = ({ closeModal }) => {
  const [password, setPassword] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const { currentPassword, newPassword, confirmPassword } = password;

  const OnChange = (e) => {
    setPassword({ ...password, [e.target.name]: e.target.value });
  };

  const UpdatePassword = async () => {
    const response = await axios
      .put(
        '/auth/updatepassword',

        {
          currentPassword,
          newPassword,
          confirmPassword,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      )
      .then((response) => {
        console.log(response);

        // localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      })
      .catch((err) => console.log(err.response.data.error));
  };

  const clickHandler = () => {
    closeModal(false);
  };

  return (
    <div className='resetpasswordModal'>
      <div id='ResetPassword' className='mb-3'>
        <div className='m-5' style={{ width: '110%' }}>
          <div className='d-flex justify-content-end' onClick={clickHandler}>
            <button
              type='button'
              class='btn-close shadow-none'
              aria-label='Close'
            ></button>
            
          </div>
          <div className="d-block text-center">
              <img
                src="/assests/logo2.png"
                alt="KIBI Sport"
                className="fluid-img"
              />
            </div>
          <div className='text-center'>
            <h1 className='mt-1 mb-4 modalHeader'>Reset Password</h1>
            <input
              type='password'
              name='currentPassword'
              value={currentPassword}
              onChange={OnChange}
              placeholder='Current Password'
              className='input-group p-3 rounded border border-secondary'
            />
            <br />
            <input
              type='password'
              name='newPassword'
              value={newPassword}
              onChange={OnChange}
              placeholder='New Password '
              className='input-group p-3 rounded border border-secondary'
            />
            <br />
            <input
              placeholder='Confirm Password'
              type='password'
              name='confirmPassword'
              value={confirmPassword}
              onChange={OnChange}
              className='input-group p-3 rounded border border-secondary'
            />
            <br />

           
            <div className='pt-0'>
              <button className='loginBtn p-3 rounded' onClick={UpdatePassword}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
